import React from 'react';

const CancelPage = () => (
  <div>
    <h2>Payment Cancelled</h2>
    <p>Your payment was not completed. Please try again.</p>
  </div>
);

export default CancelPage;
